var exports = {
  "k": "xfd349460--1b38e0--container",
};

module.exports = exports;
